import { Hyperlink as HyperlinkSDS } from '@snapchat/snap-design-system-marketing';
import type { FC, PropsWithChildren } from 'react';
import { useContext } from 'react';

import { ElementLocation } from '../../context/ElementLocationContext/ElementLocationContext';
import { shouldFlushLogs } from '../../helpers/getLocalPath';
import { logger, logUserEvent } from '../../helpers/logging';
import { UserAction } from '../../types/events';
import type { HyperlinkProps } from './types';

export const Hyperlink: FC<PropsWithChildren<HyperlinkProps>> = ({ uri, children }) => {
  const elementLocation = useContext(ElementLocation).elementLocation;

  const onClick = (): void => {
    logUserEvent({
      eventAction: UserAction.Click,
      eventCategory: 'Hyperlink',
      eventLabel: `Hyperlink: ${uri}`,
      context: {
        targetUrl: uri,
        elementLocation,
        elementText: typeof children === 'string' ? children : undefined,
      },
    });

    if (shouldFlushLogs(uri)) {
      void logger.flush();
    }
  };

  return (
    <HyperlinkSDS link={uri} onClick={onClick}>
      {children}
    </HyperlinkSDS>
  );
};

Hyperlink.displayName = 'Hyperlink';

// TODO: does this need a figma code connect?
